import api from './api';

export const openLibraryService = {
  // Get available subjects for import
  getAvailableSubjects: async () => {
    try {
      const response = await api.get('/openlibrary/search/subjects');
      return response.data;
    } catch (error) {
      console.error('Error fetching available subjects:', error);
      throw error;
    }
  },

  // Preview books by subject
  previewBooksBySubject: async (subject, limit = 20) => {
    try {
      const response = await api.get(`/openlibrary/preview/${encodeURIComponent(subject)}?limit=${limit}`);
      return response.data;
    } catch (error) {
      console.error('Error previewing books by subject:', error);
      throw error;
    }
  },

  // Preview popular books
  previewPopularBooks: async (limit = 50) => {
    try {
      const response = await api.get(`/openlibrary/preview/popular?limit=${limit}`);
      return response.data;
    } catch (error) {
      console.error('Error previewing popular books:', error);
      throw error;
    }
  },

  // Preview classic literature
  previewClassicLiterature: async (limit = 100) => {
    try {
      const response = await api.get(`/openlibrary/preview/classics?limit=${limit}`);
      return response.data;
    } catch (error) {
      console.error('Error previewing classic literature:', error);
      throw error;
    }
  },

  // Import books by subject
  importBooksBySubject: async (subject, limit = 50) => {
    try {
      const response = await api.post(`/openlibrary/import/subject?subject=${encodeURIComponent(subject)}&limit=${limit}`);
      return response.data;
    } catch (error) {
      console.error('Error importing books by subject:', error);
      throw error;
    }
  },

  // Import popular books
  importPopularBooks: async (limit = 50) => {
    try {
      const response = await api.post(`/openlibrary/import/popular?limit=${limit}`);
      return response.data;
    } catch (error) {
      console.error('Error importing popular books:', error);
      throw error;
    }
  },

  // Import classic literature
  importClassicLiterature: async (limit = 100) => {
    try {
      const response = await api.post(`/openlibrary/import/classics?limit=${limit}`);
      return response.data;
    } catch (error) {
      console.error('Error importing classic literature:', error);
      throw error;
    }
  },

  // Get Open Library statistics
  getStats: async () => {
    try {
      const response = await api.get('/openlibrary/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching Open Library stats:', error);
      throw error;
    }
  }
};